import clsx from 'clsx';

import { DataTestId } from '@pflegia/types/api/general/data-test-id';

interface Props extends DataTestId {
  label?: string;
  position?: 'left' | 'right';
  shouldAnimate?: boolean;
  size?: 'small' | 'large';
  className?: string;
}

const NotificationMarker: React.FC<Props> = ({
  label,
  position = 'right',
  shouldAnimate = false,
  size = 'small',
  className,
  'data-testid': dataTestId,
}) => (
  <span
    data-testid={dataTestId}
    aria-label={label}
    className={clsx(
      'absolute top-0 mt-0.5 flex',
      {
        'left-0': position === 'left',
        'right-0': position === 'right',
        'h-2 w-2': size === 'small',
        'h-4 w-4': size === 'large',
      },
      className,
    )}>
    {shouldAnimate && <span className='bg-declined absolute inline-block h-full w-full animate-ping rounded-full opacity-75' />}
    <span className='bg-declined relative inline-block h-full w-full rounded-full' />
  </span>
);

export default NotificationMarker;
